<div class="subBlockContent" id="editkaspenduser">
  <div class="inner-subBlock-wrapper">
    <div class="page-title-wrapper">
      <div class="title blade-title-font">
        {{title}}
      </div>
      <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
    </div>
    <div class="row" [formGroup]="userFormGroup">
      <div class="userinfo col-md-6">
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantNameValidate" formControlName="out_company_name" placeholder="Tenant Name">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="tenantIdValidate" formControlName="out_tenant_id" placeholder="Tenant ID">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantDescriptionValidate" formControlName="out_tenant_desc"
            placeholder="Tenant Description">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantFirstNameValidate" formControlName="out_first_name" placeholder="First Name">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantLastNameValidate" formControlName="out_last_name" placeholder="Last Name">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantEmailValidate" formControlName="out_email" placeholder="Email">
        </mat-form-field>

        <mat-form-field [floatLabel]="'always'" hidden>
          <input matInput formControlName="out_customer_id">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'" hidden>
          <input matInput formControlName="out_country">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'" hidden>
          <input matInput formControlName="out_culture">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'" hidden>
          <input matInput formControlName="out_digital_wallet_id">
        </mat-form-field>
      </div>

      <div class="userinfo col-md-6">
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantAddressLine1Validate" formControlName="out_address_1"
            placeholder="Address Line 1">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantAddressLine2Validate" formControlName="out_address_2"
            placeholder="Address Line 2">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantAddressLine3Validate" formControlName="out_address_3"
            placeholder="Address Line 3">
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantCityValidate" (input)="onInputSub($event)"
            #myAutocompleteTriggerSub="matAutocompleteTrigger" [matAutocomplete]="autoSuburb"
            formControlName="out_city" placeholder="SUBURB" (keydown.Tab)="chooseAutoCompletSuburb($event)"
            (suburb)="startFilterSub($event)" required>
          <mat-autocomplete #autoSuburb="matAutocomplete">
            <mat-option *ngFor="let option of filteredSub" [value]="option?.suburb"
              (click)="chooseAutoComplete(option)">
              {{option?.suburb+", "+option?.state+", "+option?.postcode}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <!-- <mat-form-field [floatLabel]="'always'">
          <mat-select class="editTenantStateValidate" placeholder="State" formControlName="out_region" required>
            <mat-option value="{{state}}" *ngFor="let state of stateList">{{state}}</mat-option>
          </mat-select>
        </mat-form-field> -->
        <ng-select class="customDropdwon editTenantStateValidate" [items]="stateList" bindValue="state"
          bindLabel="state" placeholder="State *" formControlName="out_region"></ng-select>
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantPostCodeValidate" maxlength="4"
            #myAutocompleteTriggerPostcode="matAutocompleteTrigger" (input)="onInputPostcode($event)"
            (keypress)="isNumberKey($event)" formControlName="out_post_code" (postcode)="startFilterPostcode($event)"
            (keydown.Tab)="chooseAutoCompletPostcode($event)" [matAutocomplete]="autoPostcode" placeholder="POST CODE"
            required>
          <mat-autocomplete #autoPostcode="matAutocomplete">
            <mat-option *ngFor="let option of filteredPostCode" [value]="option?.postcode"
              (click)="chooseAutoComplete(option)">
              {{option?.suburb+", "+option?.state+", "+option?.postcode}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field [floatLabel]="'always'">
          <input matInput class="editTenantPhoneNumberValidate" formControlName="out_phone" placeholder="Phone Number">
        </mat-form-field>
      </div>
    </div>
    <loading-screen *ngIf="loadContent" [showBlurTable]="false" backDropWidth="984" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
  <div class="button-center">
    <button class="button button-red button-large" (click)="updateEndUser()">Save</button>
  </div>
</div>